import type { HasAvatar } from "@qendo/profile";
import { useMemo } from "react";
import { type AvatarImageProps, Avatar as PaperAvatar } from "react-native-paper";
import { useApi } from "~/providers/ApiProvider";
import { useProfile } from "~/providers/ProfileProvider";
import { useUser } from "~/providers/UserProvider";

export type AvatarProps = {
    target?: HasAvatar;
} & Omit<AvatarImageProps, "source">;

export const Avatar = ({ target, ...imageProps }: AvatarProps) => {
    const { profile } = useProfile();
    const { user } = useUser();
    const { img } = useApi();

    // biome-ignore lint/correctness/useExhaustiveDependencies(img): API
    const source = useMemo(() => {
        const file = target ? target.avatar : profile.avatar || user.avatar;

        return file ? img(file) : require("~/assets/logo-round.png");
    }, [target, profile, user]);

    return <PaperAvatar.Image {...imageProps} source={source} />;
};
